import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { TaskStatusesFilterOptions } from '../task.constants';
import { ITask, ITaskFilter } from '../task.interface';
import { TaskHttpService } from '../task-http.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-task-search',
  templateUrl: './task-search.component.html',
  styleUrls: ['./task-search.component.css']
})
export class TaskSearchComponent implements OnInit {
  tasks: ITask[] = [];
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  formValueChanged: boolean = false;
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: ITaskFilter = {
    filters: {},
    sort: '',
    skip: 0,
    limit: 50
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions: any = {
    "title": 'Titulo asc',
    "-title": 'Titulo desc',
    "status": 'Estado asc',
    "-status": 'Estado desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  taskStatuses: any = TaskStatusesFilterOptions;
  taskStatusesKeys = Object.keys(TaskStatusesFilterOptions);
  isDev!: boolean;
  status!: string;
  clientId!: string;
  project: any;

  constructor(
    public _TaskHttpService: TaskHttpService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _AuthService: AuthService,
    private alertService: AlertService,
  ) {
    self = this;
    this.dialog = dialogRef;
    this.registerStringBroadcast();
  }

  ngOnInit() {
    const filter: any = this.filter;

    if (this.status) {
      this.taskStatusesKeys = [this.status];
      filter.filters.status = this.status;
    }

    if (this.clientId) {
      filter.filters.clientId = this.clientId;
    }

    if (this.project) filter.filters.project = this.project;

    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getTasks(true);

    // disable click outside modal
    self.dialogRef.disableClose = true;
    self.dialogRef.backdropClick().subscribe(() => {
      if (!this.readOnly && this.formValueChanged) {
        const modalOptions: IConfirmationDialogOptions = {
          title: "Salir",
          message: "¿Está seguro de que desea salir? Los cambios no se guardarán",
          yesButtonLabel: 'Sí, deseo salir', noButtonLabel: 'Cancelar'
        };
        this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).subscribe((confirmation: any) => {
          if (confirmation) self.dialogRef.close();
        });
      } else {
        self.dialogRef.close();
      }
    })

  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getTasks(true);
      }
    }, 1000);
  }

  getTasks(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.tasks = [];
      this.clearSelection();
    }
    const filter: any = _.cloneDeep(this.filter);
    /*
    if (_.get(filter, 'filters.created_at_start'))
      filter.filters.created_at_start = new Date(filter.filters.created_at_start).getTime();
    if (_.get(filter, 'filters.created_at_end'))
      filter.filters.created_at_end = new Date(filter.filters.created_at_end).getTime();
      */
    if (filter.filters.client == '') delete filter.filters.client;
    if (filter.filters.title == '') delete filter.filters.title;
    this._TaskHttpService.getTasks(filter).subscribe((tasks: any) => {
      //console.log(tasks)
      if(!this.project){
        let taskFiltered = tasks.filter((task: any) => !task.project);
        this.tasks = _.concat(this.tasks, taskFiltered);
        this.thereAreMore = taskFiltered.length >= filter.limit;
      } else {
        this.tasks = _.concat(this.tasks, tasks);
        this.thereAreMore = tasks.length >= filter.limit;
      }
      this.loading = false;
    })
  }

  closeDialog(task: any) {
    if (task.serviceAgreement) {
      this.alertService.warn('Trabajo no facturable, pertenece a un contrato');
    } else {
      task.existTask = true;
      this.dialog.close(task)
    }
  }
  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getTasks();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortTasks(sort: Sort | string) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getTasks(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = {};
    this.getTasks(true);
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.tasks.every(task => {
        const id = task?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.tasks.forEach(task => {
        const id = task?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }

  openTasksByStatus() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-status']);
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "Ups!",
      message: "El enlace se encuentra en construccion",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }
}